import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { Observable, BehaviorSubject, of, Subject } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { User, UserSearchableDto, UsersService, PaginatedUsersResponse } from './users.service'; 


export class UsersDataSource implements DataSource<User> {

  private usersSubject = new BehaviorSubject<User[]>([]);
  private loadingSubject = new BehaviorSubject<boolean>(false);
  private countSubject = new BehaviorSubject<number>(0); 

  public loading$ = this.loadingSubject.asObservable();
  public counter$ = this.countSubject.asObservable();
  public errors$ = new Subject<boolean>(); 

  constructor(private usersService: UsersService) { }

  connect(collectionViewer: CollectionViewer): Observable<User[]> {
    return this.usersSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.usersSubject.complete();
    this.loadingSubject.complete();
    this.countSubject.complete();
    this.errors$.complete();
  }

  /**
   * Carica gli utenti dal servizio.
   * @param filters Criteri di ricerca.
   * @param sort Active sort column and direction (e.g., 'cognome,asc').
   * @param pageIndex Indice della pagina.
   * @param pageSize Dimensione della pagina.
   */
  loadUsers(
    filters: UserSearchableDto,
    sort: string,
    pageIndex: number,
    pageSize: number
  ): void {
    this.loadingSubject.next(true);
    this.errors$.next(false); 

    const [sortColumn, sortDirection] = sort.split(',');

    this.usersService.getUsersByEnte(filters, sortColumn, sortDirection, pageIndex, pageSize)
      .pipe(
        catchError(err => {
          console.error("Errore nel caricamento degli utenti:", err);
          this.errors$.next(true); 
          return of({ content: [], totalElements: 0 } as PaginatedUsersResponse); 
        }),
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe(response => {
        this.usersSubject.next(response.content);
        this.countSubject.next(response.totalElements);
      });
  }
}